import { createRoute } from "@tanstack/solid-router";
import { localDateKey } from "@journal/shared";
import { appRoute } from "./route";
// DayView is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// No <Suspense> skeleton wraps it: it's local-first (SQLite reads resolve in
// ~50ms) and hydrates synchronously from the TanStack cache, so a skeleton
// would only flash + cause a remount. All its queries are non-suspending.
import { DayView } from "@/features/journal/components/day-view";

function TodayPage() {
  return <DayView dateKey={() => localDateKey()} />;
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: TodayPage,
});
